import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=61f02f07&scoped=true&"
import script from "./commission.vue?vue&type=script&lang=js&"
export * from "./commission.vue?vue&type=script&lang=js&"
import style0 from "./commission.vue?vue&type=style&index=0&id=61f02f07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f02f07",
  null
  
)

export default component.exports